import React from "react";
import TrialSubscription from "./TrailSubscription";
import FreeSubscription from "./FreeSubscription";
import PaidSubscription from "./PaidSubscription";
import ReadOnlySubscription from "./ReadOnlySubscription";
import SubscriptionPanelHeader from "./SubscriptionPanelHeader";
import { NotImplementedSubscription } from "../../../Subscription/Components/CommonPanelContent";
import { routes } from "utilities/routing/generatedRoutes";
import { ButtonPrimary } from "components/Atoms/Button";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const PanelContent = (props: Props) => {
  switch (props.activeSubscription.type) {
    case "trial":
      return (<TrialSubscription {...props} />);
    case "free":
      return (<FreeSubscription {...props} />);
    case "paid":
      return (<PaidSubscription {...props} />);
    case "readOnly":
      return (<ReadOnlySubscription {...props} />);
    default:
      return (<NotImplementedSubscription />);
  }
};

const SubscriptionInfoPanel = (props: Props) => (
  <div className="s1_panel">

    <div className="content-section flex-column gap-big">

      <div style={{ alignSelf: "center" }}>
        <SubscriptionPanelHeader
          activeSubscription={props.activeSubscription}
          nextSubscriptionType={props.nextSubscriptionType}
        />
      </div>

      <PanelContent {...props} />
      <div className="subscription-info-panel-details-button">
        <ButtonPrimary
          href={routes.subscription_Detail().absolute}
          label={RESX.GeneralLabels.Details}
          iconRight="icon-angle-right"
        />
      </div>
    </div>
  </div>
);

export default SubscriptionInfoPanel;
